export default "__VITE_ASSET__B7tBm2So__"